// Returns the number of seconds to display in the Watch History "Watched"
// column. This is intentionally the furthest playback POSITION reached
// (capped at the video length), NOT the cumulative seconds played.
//
// Why: the "Progress %" and "Completed" status are both derived from
// `lastPosition` (see getProgressData). The cumulative play-time
// (`dailyBreakdown` sum) is a different quantity that routinely under-counts a
// fully-watched video (throttled progress ticks, buffering, partial seeks,
// floor rounding) and over-counts re-watches. Showing that cumulative figure
// next to a position-based percentage made the two columns disagree
// (e.g. "16s watched" beside "99%"). Deriving the displayed watched time from
// the same `lastPosition` keeps Progress %, Watched and Status consistent.
//
// The genuine cumulative play-time is still surfaced in the stat cards
// (Platform Time / Playtime) and the CSV export.
const getWatchedSeconds = (lastPosition, video) => {
  const position = Number(lastPosition);
  const length = Number(video?.videoLength);
  if (!Number.isFinite(position) || position <= 0) return 0;
  if (Number.isFinite(length) && length > 0) return Math.min(position, length);
  return position;
};

export default getWatchedSeconds;
